<template>
  <div class="flex flex-col py-2 text-sm text-gray-600 bg-white rounded-md shadow-md">
    <div
      class="flex px-3 py-1 transition cursor-pointer hover:bg-gray-100"
      :class="`${item.border ? 'border-b border-gray-100 mb-2' : ''} `"
      v-for="item in filterMenuList"
      :key="item.action"
      @click="onClick(item)"
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import router from '@/router';
import { useTagsViewStore } from '@/store/modules/tagsView';
import { computed, PropType, reactive, toRefs } from 'vue';

const props = defineProps({
  onClose: {
    type: Function as PropType<() => void>,
    default: () => {},
  },
  menuInfo: {
    type: Object as PropType<any>,
    default: () => {
      return {};
    },
  },
});
const { menuInfo } = props;
const _data = reactive({
  menuList: [
    { name: '重新加载', icon: '', action: 'reload' },
    { name: '关闭页面', icon: '', action: 'close', border: true },
    { name: '关闭左侧页面', icon: '', action: 'closeLeft' },
    { name: '关闭右侧页面', icon: '', action: 'closeRight', border: true },
    { name: '关闭其他页面', icon: '', action: 'closeOther' },
    { name: '关闭所有页面', icon: '', action: 'closeAll' },
  ],
});
const { menuList } = toRefs(_data);
const tagStore = useTagsViewStore();
const tagList = computed(() => tagStore.getVisitedViews);

// 过滤菜单：如果当前页面有 allowShow，则隐藏关闭相关菜单
const filterMenuList = computed(() => {
  if (menuInfo.allowShow) {
    // allowShow 为 true，隐藏关闭页面和相关操作
    return menuList.value.filter((item) => !['close', 'closeLeft', 'closeRight', 'closeOther', 'closeAll'].includes(item.action));
  }
  return menuList.value;
});

const onClick = (item: { action: any }) => {
  switch (item.action) {
    case 'reload':
      tagStore.setSelectedTag(menuInfo);
      // 使用重定向路由实现页面刷新
      const { path } = menuInfo;
      router.push({
        path: `/redirect${path}`,
        query: { redirect: path }
      }).then(() => {
        router.push(path);
      });
      break;
    case 'close':
      closeCurrentPage();
      break;
    case 'closeLeft':
      tagStore.delLeftViews(menuInfo);
      break;
    case 'closeRight':
      tagStore.delRightViews(menuInfo);
      break;
    case 'closeOther':
      closeOtherPages();
      break;
    case 'closeAll':
      tagStore.delAllVisitedViews();
      setTimeout(() => {
        if (tagList.value.length > 0) {
          const item = tagList.value[0];
          tagStore.setSelectedTag(item);
          router.push(item.path);
        } else {
          // 没有标签页了，跳转到首页
          router.push('/dashboard/home');
          tagStore.setSelectedByPath('/dashboard/home');
        }
      }, 0);
      break;
    default:
  }
  props.onClose();
};

// 关闭当前页面，并跳转到上一个标签页或首页
const closeCurrentPage = () => {
  const currentIndex = tagList.value.findIndex((v) => v.path === menuInfo.path);
  if (currentIndex < 0) return;
  
  tagStore.delVisitedView(menuInfo);
  
  // 查找上一个标签页
  const prevIndex = currentIndex - 1;
  if (prevIndex >= 0 && tagList.value[prevIndex]) {
    const prevTag = tagList.value[prevIndex];
    tagStore.setSelectedTag(prevTag);
    router.push(prevTag.path);
  } else {
    // 没有上一个标签页，则跳转到首页
    router.push('/dashboard/home');
    tagStore.setSelectedByPath('/dashboard/home');
  }
};

// 关闭其他页面，如果当前页面也被删除，则跳转到首页
const closeOtherPages = () => {
  const beforeLength = tagList.value.length;
  tagStore.delOthersVisitedViews(menuInfo);
  
  // 检查当前页面是否还存在
  const currentStillExists = tagList.value.some((v) => v.path === menuInfo.path);
  if (!currentStillExists && beforeLength > 1) {
    // 如果当前页面被删除了，跳转到首页
    router.push('/dashboard/home');
    tagStore.setSelectedByPath('/dashboard/home');
  }
};
</script>

<style></style>
